export const BACKGROUND_IMAGE_ASPECT_RATIO = 9 / 16
